module.exports = __webpack_public_path__ + "img/612f5a7.png";